import { render, staticRenderFns } from "./SelectOrderBy.vue?vue&type=template&id=e822cb9c&"
import script from "./SelectOrderBy.vue?vue&type=script&lang=js&"
export * from "./SelectOrderBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports